// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

// Components
import CarType from 'Common/CarType';

// Helpers
import classNames from 'classnames';
import { createValue } from 'Common/formValues';
import { topEightCarTypes } from 'Common/filterValues';
/**
 * <CarTypes /> component.
 */
class CarTypes extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    fields: PropTypes.object,
    additonalOptions: PropTypes.object,
    isLoading: PropTypes.bool
  };

  /**
   * Renders <CarTypes /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Node {
    const { styles, fields, isLoading } = this.props;
    const { category } = this.props.additonalOptions;

    const orderedCategories = topEightCarTypes.map(_ =>
      category.filter(item => item.key === _.key)[0]
        ? category.filter(item => item.key === _.key)[0]
        : _
    );

    return (
      <div className={classNames(styles.formRow, styles.formRowCarTypes)}>
        {orderedCategories &&
          orderedCategories.map((item, index) => (
            <div className={styles.formRowItem} key={index}>
              <CarType
                key={index}
                firstOfType={index === 0}
                name={'category'}
                size={'medium-xlarge'}
                label={item.key}
                results={
                  (item.doc_count && item.doc_count.toLocaleString('en')) || 0
                }
                selectedValue={fields.category}
                value={createValue(item)}
                isDisabled={isLoading}
              />
            </div>
          ))}
      </div>
    );
  }
}

export default CarTypes;



// WEBPACK FOOTER //
// ./src/Home/CarTypes/index.js